import createGetFormSyncErrors from './selectors/getFormSyncErrors';
import plain from './structure/plain';

export default createGetFormSyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormSyncErrors.js
// module id = 1925
// module chunks = 1